import PropTypes from 'prop-types';
import React from 'react';
import { useLocale } from 'next-intl';
import CloseIcon from '../../icons/close.svg';
import StyledDateHeader from './dateHeader.style';

const EventShape = () => (
  <svg width="77" height="78" viewBox="0 0 164 164" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 35.55v120.926S2 162 6.625 162h150.75s4.625 0 4.625-5.22V7.219S162 2 157.375 2H37.43C36.543 2 2 35.105 2 35.55z"
      stroke="#000"
      strokeWidth="6"
      fill="#00000000"
      fillRule="evenodd"
    />
  </svg>
);

const DateHeader = ({ date, cancelable = false, handleCancelClick = () => {}, ...props }) => {
  const locale = useLocale();
  return (
    <StyledDateHeader {...props}>
      <div className="dateHeader_Bar">
        <div className="dateHeader__dateWrapper">
          <div className="dateHeader_indicator">
            <EventShape />
            <span>{new Date(date).getDate()}</span>
          </div>
          <div className="dateHeader__datelabel">
            {new Date(date).toLocaleDateString(locale, {
              weekday: 'long',
              day: 'numeric',
              month: 'long'
            })}
          </div>
        </div>
        {cancelable && (
          <div
            className="dateHeader__close"
            role="button"
            onClick={handleCancelClick}
            tabIndex={0}
            onKeyDown={handleCancelClick}
          >
            <CloseIcon width={16} height={16} />
          </div>
        )}
      </div>
    </StyledDateHeader>
  );
};

DateHeader.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  cancelable: PropTypes.bool,
  handleCancelClick: PropTypes.func
};

export default DateHeader;
